import { useState, useEffect } from "react";
import { Card, CardHeader, Stack, Button, ButtonGroup, Tooltip } from "@mui/material";
import DashboardLayout from "../layoutcontainers/DashboardLayout";
import MaterialButton from "../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import MaterialTypography from "../components/MaterialTypography";
import MaterialSelect from "../components/MasterSelect";
import MaterialBox from "../components/MaterialBox";
import MaterialDataGrid from "../components/MaterialDataGrid";
import { useNavigate } from "react-router-dom";
import BASEURL from "../pages/Utils/Baseurl";
import axios from "axios";
import { LuEye } from "react-icons/lu";
import Badge from "@mui/material/Badge";
import { useUserDetails } from "../context/auth";
import ReusableFilter from "../ReusableFilter";
import { getalldepartment, getjobids } from "./query";
import { apicall } from "../Integration/apicall";
import { FaFilter } from "react-icons/fa";
import { IoRefreshCircle } from "react-icons/io5";
const ScreeningTable = () => {
  const nav = useNavigate();
    const [filterparam, setfilterparam] = useState([]);
  
  
    const [openfilter, setopenfilter] = useState(false);
  const { AccessData } = useUserDetails();
  const department = {
    value: "",
  };

  useEffect(() => {
    fetchData();

  }, []);

   useEffect(() => {
      Promise.all([apicall(getalldepartment), apicall(getjobids)]).then(
        ([departmentdata, jobdata]) => {
          console.log("department res", departmentdata?.data?.data);
          console.log("job res", jobdata?.data?.data);
          let departments = departmentdata?.data?.data?.allDepartment;
          let jobs = jobdata?.data?.data?.allStaffRequests;
          console.log(jobs, "alljobs found");
  
          jobs = jobs?.map((job) => ({
            value: job?.jobid,
            label: job?.jobid,
            field: "jobid",
          }));
  
          departments = departments?.map((department) => ({
            value: department?.departmentName,
            label: department?.departmentName,
            field: "department",
          }));
  
          setfilterparam([
            {
              field: "JobId",
              options: jobs,
            },
            {
              field: "department",
              options: departments,
            },
          ]);
        }
      );
    }, []);
   
    const handleclosefilter = () => {
    setopenfilter(false);
  };

  const handleclick = () => {
    nav("/sourcing/create-Sourcing");
  };



  

  
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [tabledata, settabledata] = useState([]);

  const [alljobid, setalljobid] = useState([]);


  const SalaryStructureListTable = {
    columns: [
      {
        field: "sno",
        headerName: "S.No",
        width: 110,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "jobid",
        headerName: "Job ID",
        width: 130,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "position",
        headerName: "Role",
        width: 130,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "candidateName",
        headerName: "Candidate Name",
        width: 130,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "source",
        headerName: "Source",
        width: 130,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "mobileNumber",
        headerName: "Mobile No",
        width: 130,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "emailid",
        headerName: "Mail ID",
        width: 130,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "screeningStatus",
        headerName: "Screening Status",
        width: 130,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "map",
        headerName: "Actions",
        width: 130,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
    ],

    rows: tabledata.map((data,index) => ({
      sno: index + 1, 
      id: data.id,
      jobid: data.jobid,
      position: data.position,
      candidateName: data.candidateName,
      screeningStatus:
        data.screeningStatus == "Selected"
          ? "Selected"
          : data.screeningStatus == "Rejected"
          ? "Rejected"
          : "Pending",
      source: data.source,
      mobileNumber: data.mobileNumber,
      emailid: data.emailid,
      manuallyaddedcandidate:data?.manuallyAdd,
      map: (
        <>
          <Button
            onClick={(e) => {
              e.stopPropagation(); // Prevent onRowClick from triggering
              nav(`/sourcing/createscreening?id=${data?.id}`, {
                state: { rowData: data }, // Pass row data if needed
              });
            }}
            sx={{
              border: "1px solid #3F51B5d4",
              color: "#3F51B5d4",
              backgroundColor: "white",
              padding: "8px 16px",
              borderRadius: "8px",
              fontWeight: "bold",
              textTransform: "uppercase",
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "#3F51B5d4",
                color: "#ffffff",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
              },
              "&:active": {
                backgroundColor: "#303F9F", // Slightly darker shade for active state
                borderColor: "#303F9F",
              },
            }}
          >
            Screening
          </Button>
        </>
      ),
    })),
  };

  console.log("tabledata:", tabledata);

  // const handlechange = (event, setevent) => {
  //   console.log(setevent.name + "settev");

  //   if (setevent.name == "department") {
  //     const cloneddepartment = { ...Department };
  //     cloneddepartment.value = event;
  //     SetDepartment(cloneddepartment);
  //   } else if (setevent.name == "status") {
  //     const clonedstatus = { ...Status };
  //     clonedstatus.value = event;
  //     console.log(clonedstatus + "clonedstatus");
  //     setStatus(clonedstatus);
  //   } else {
  //     const clonedjobid = { ...jobid };
  //     clonedjobid.value = event;
  //     setjobid(clonedjobid);
  //   }
  // };

  const departmentName = [
    {
      id: "HR",
      departmentName: "hr",
    },

    {
      id: "Dev",
      departmentName: "dev",
    },

    {
      id: "DEV",
      departmentName: "dev",
    },
  ];






  const [Opendata, setOpendata] = useState([]);
  const [Matchingdata, setMatchingdata] = useState([]);
  const [Notify, setNotify] = useState("");

  useEffect(() => {
    handlecheck();
  }, [Opendata, Matchingdata]);

  const handlecheck = () => {
    let fiildata = Opendata.filter(
      (dat) => !Matchingdata.some((val) => val.jobid === dat.jobid)
    );

    let data = fiildata.length;
    setNotify(data);
  };

 

  const fetchData = async () => {
    const query = `query {
  allSourcingScreenings {
    id
    jobid
    candidateName
    screeningStatus
    source
    mobileNumber
    position
    department
    emailid
    totalExperience
    relevantExperience
    currentCtc
    expectedCtc
    leadTime
    yearOfPassing
    currentEmployer
    location
    comments
    interviewAvailability
    interviewer
    cvFile
    manuallyAdd
  }
}`;

    try {
      setPageState((prev) => ({ ...prev, loading: true }));


      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("response:", response.data.data.allSourcingScreenings);

      let result = response.data.data.allSourcingScreenings?.filter(
          (item) => item?.manuallyAdd === false)

      setMatchingdata(result);

      let Jobdata = Array.from(new Set(result.map((val) => val.jobid))).map(
        (jobid) => ({ jobid })
      );

      console.log("Unique Jobdata:", Jobdata);

      console.log("Jobdata:", Jobdata);

      setalljobid(Jobdata);

      settabledata(result);
     
     
      setPageState((prev) => ({ ...prev, loading: false, state: "success" }));
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({ ...pageState, loading: false, error: true, message: error.message });
    }
  };

  console.log("sampledata:", alljobid);

  const onRowClick = (e) => {
    console.log("sourcingdata", e);

    console.log("onDepartmentListClick:", e?.id, e);
    if (e?.id) {
       if(e.row?.manuallyaddedcandidate){
         nav(`/recruitment/add-candidate?id=${e?.row?.jobid}`);
       }
       else{
           nav(`/sourcing/create-Sourcing?id=${e?.id}`);
       }
   
    }
  };





 





  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                margin={1}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Source and Screen
                  </MaterialTypography>
                  {/* <MaterialTypography variant="caption" color="text">
                                List of Employee Salary that you can get details of Employee Salary.
                            </MaterialTypography> */}
                </Stack>

                <Stack direction="row">
                  <ButtonGroup variant="outlined" size="small" color="#000">
                    <Tooltip title="Filter the table" disableInteractive arrow>
                      <MaterialButton onClick={() => setopenfilter(true)}>
                        <FaFilter size={16} color="black" />
                      </MaterialButton>
                    </Tooltip>
                    <Tooltip title="Refresh/Reset the table" disableInteractive arrow>
                      <MaterialButton onClick={fetchData}>
                        <IoRefreshCircle size={20} color="black" />
                      </MaterialButton>
                    </Tooltip>
                  </ButtonGroup>
                </Stack>
                {AccessData &&
                  Array.isArray(AccessData) &&
                  AccessData.some(
                    (item) =>
                      item.component === "AddSourcing" && item.can_access
                  ) && (
                    <Stack alignItems="center" lineHeight={1}>
                      <Badge
                        badgeContent={Notify}
                        sx={{
                          "& .MuiBadge-badge": {
                            backgroundColor: "#e04949",
                            color: "#ffffff",
                          },
                        }}
                      >
                        {/* Your component here, e.g., an icon or button */}

                        <MaterialButton
                          variant="gradient"
                          color="dark"
                          size="small"
                          startIcon={<AddIcon />}
                          onClick={handleclick}
                        >
                          Source Profile
                        </MaterialButton>
                      </Badge>
                    </Stack>
                  )}
              </Stack>

           
            </>
          }
        />
        <MaterialDataGrid
          // customHeight={550}
          rows={SalaryStructureListTable.rows}
          columns={SalaryStructureListTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={onRowClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No Source & Screen found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any Source & Screen details. Click on the
                  "Source Profile" button to start adding Source Profile
                  details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
           <ReusableFilter
          filterparam={filterparam}
          setfilterparam={setfilterparam}
          setfilterdata={settabledata}
          openfilter={openfilter}
          handleclosefilter={handleclosefilter}
          unfiltereddata={tabledata}
        />
      </Card>
    </DashboardLayout>
  );
};
export default ScreeningTable;
